import React from 'react';
import { Img } from 'react-image';
import { Link } from 'react-router-dom';
import { Navbar } from 'flowbite-react';
import { useThemeContext } from 'src/context/ThemeProvider';

const OpportunitiesDriveHeader = () => {
	const { themeMode } = useThemeContext();
	return (
		<div className="fixed top-0 left-0 w-full z-50 flex justify-between items-center dark:text-white">
			<Navbar
				className={`rounded-none w-full md:!px-[45px] !px-[10px] bg-white dark:bg-[#18222D]`}
				fluid={true}
				rounded={true}
			>
				<div className="flex gap-8 items-center ">
					<Link to="/" className="flex items-center ">
						<Img
							loading="lazy"
							src={
								themeMode === 'dark'
									? 'https://masai-website-images.s3.ap-south-1.amazonaws.com/level_Up_By_Masai_Icon_Dark_a5f53496b9.svg'
									: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/level_Up_By_Masai_Icon_Dark_a5f53496b9.svg'
							}
							width="110"
							height="32px"
							alt="LevelUp Logo"
						/>
					</Link>
				</div>
			</Navbar>
		</div>
	);
};

export default OpportunitiesDriveHeader;
